module.exports = __webpack_public_path__ + "img/icon_leaf_circle.342d1340.svg";